/** Doodles decorativos do menu lateral — temática jurídica, tom suave sobre o verde. */
export default function AppSidebarDoodles() {
  const s = {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.4,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  };

  return (
    <div className="app-sidebar__doodles" aria-hidden>
      {/* Balança da justiça */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--scales" viewBox="0 0 72 80">
        <path {...s} d="M36 8v58" />
        <path {...s} d="M14 22c8-2 16-2 24 0 8 2 16 2 24 0" />
        <path {...s} d="M18 22v6c0 8-4 14-10 16" />
        <path {...s} d="M54 22v6c0 8 4 14 10 16" />
        <path {...s} d="M8 44c4 2 8 2 12 0 4-2 8-2 12 0 4 2 8 2 12 0 4-2 8-2 12 0" />
        <path {...s} d="M20 44c0 6-3 10-8 10s-8-4-8-10" />
        <path {...s} d="M52 44c0 6 3 10 8 10s8-4 8-10" />
        <path {...s} d="M30 66h12" />
      </svg>

      {/* Martelo (gavel) */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--gavel" viewBox="0 0 64 64">
        <path {...s} d="M12 52l32-32" />
        <path {...s} d="M38 14l12 12-6 6-12-12z" />
        <path {...s} d="M44 8l8 8" />
        <path {...s} d="M8 56h20" />
        <ellipse {...s} cx="50" cy="18" rx="6" ry="4" transform="rotate(-45 50 18)" />
      </svg>

      {/* Coluna clássica */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--column" viewBox="0 0 48 96">
        <path {...s} d="M8 20h32" />
        <path {...s} d="M10 20v4h28v-4" />
        <path {...s} d="M14 24v52" />
        <path {...s} d="M24 24v52" />
        <path {...s} d="M34 24v52" />
        <path {...s} d="M8 76h32" />
        <path {...s} d="M6 80h36v4H6z" />
        <path {...s} d="M12 12c4-4 8-4 12 0 4 4 8 4 12 0" />
      </svg>

      {/* Livro aberto */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--book" viewBox="0 0 72 56">
        <path {...s} d="M6 10c12-4 24-4 36 0v40c-12-4-24-4-36 0V10z" />
        <path {...s} d="M36 10c12-4 24-4 36 0v40c-12-4-24-4-36 0V10z" />
        <path {...s} d="M36 10v40" />
        <path {...s} d="M14 22h8M14 30h10M14 38h6" />
        <path {...s} d="M42 22h8M40 30h10M44 38h6" />
      </svg>

      {/* Ramo de louros */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--laurel" viewBox="0 0 80 48">
        <path {...s} d="M6 28c12-8 28-10 40-4" />
        <path {...s} d="M74 28c-12-8-28-10-40-4" />
        <path {...s} d="M18 26c-2-4 0-8 4-6M26 22c-2-4 0-8 4-6M34 20c-2-4 0-8 4-6" />
        <path {...s} d="M62 26c2-4 0-8-4-6M54 22c2-4 0-8-4-6M46 20c2-4 0-8-4-6" />
        <circle {...s} cx="40" cy="30" r="3" />
      </svg>

      {/* Símbolo de parágrafo (§) */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--paragraph" viewBox="0 0 32 48">
        <path
          {...s}
          strokeWidth={1.6}
          d="M20 8c0-4-3-6-8-6-6 0-10 3-10 8 0 5 4 7 10 7h2c6 0 10 3 10 8s-4 8-10 8c-5 0-8-2-8-6"
        />
        <path {...s} d="M14 36v8" />
      </svg>

      {/* Templo / fachada */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--courthouse" viewBox="0 0 88 56">
        <path {...s} d="M4 48h80" />
        <path {...s} d="M12 48V28M28 48V28M44 48V20M60 48V28M76 48V28" />
        <path {...s} d="M8 28h72" />
        <path {...s} d="M0 28L44 8l44 20" />
        <path {...s} d="M36 48h16v8H36z" />
      </svg>

      {/* Pena / tinteiro (escrita jurídica) */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--quill" viewBox="0 0 56 56">
        <path {...s} d="M8 48c8-4 20-16 28-32 4-8 6-12 8-14 2 2 0 6-4 10-16 12-24 24-28 32" />
        <path {...s} d="M36 12c2 2 4 2 6 0" />
        <path {...s} d="M6 50h12" />
      </svg>

      {/* Pergaminho / diploma */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--scroll" viewBox="0 0 52 64">
        <path {...s} d="M10 12c0-4 4-6 10-6h12c6 0 10 2 10 6v40c0 4-4 6-10 6H20c-6 0-10-2-10-6V12z" />
        <path {...s} d="M10 12c-4 2-6 6-6 10v32c0 4 2 8 6 10" />
        <path {...s} d="M42 12c4 2 6 6 6 10v32c0 4-2 8-6 10" />
        <path {...s} d="M18 24h16M18 32h12M18 40h14" />
      </svg>

      {/* Espada da justiça */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--sword" viewBox="0 0 40 88">
        <path {...s} d="M20 6v52" />
        <path {...s} d="M12 58h16l-2 8h-12z" />
        <path {...s} d="M16 66v14M24 66v14" />
        <path {...s} d="M14 80h12" />
        <path {...s} d="M8 14l12-6 12 6" />
        <path {...s} d="M20 8v4" />
      </svg>

      {/* Selo oficial */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--stamp" viewBox="0 0 56 56">
        <circle {...s} cx="28" cy="28" r="18" />
        <circle {...s} cx="28" cy="28" r="12" />
        <path {...s} d="M28 10v4M28 42v4M10 28h4M42 28h4" />
        <path {...s} d="M16 16l3 3M37 37l3 3M40 16l-3 3M19 37l-3 3" />
        <path {...s} d="M22 32h12M24 28h8" />
      </svg>

      {/* Maleta do advogado */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--briefcase" viewBox="0 0 64 48">
        <path {...s} d="M8 18h48v26H8z" />
        <path {...s} d="M22 18v-6c0-4 4-6 10-6s10 2 10 6v6" />
        <path {...s} d="M8 28h48" />
        <path {...s} d="M28 28v6h8v-6" />
      </svg>

      {/* Venda da justiça (olhos vendados) */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--blindfold" viewBox="0 0 64 40">
        <path {...s} d="M8 20c8-6 16-8 24-8s16 2 24 8" />
        <path {...s} d="M8 20c0 6 4 10 10 10h28c6 0 10-4 10-10" />
        <path {...s} d="M20 20h24" />
        <path {...s} d="M4 20c-2 0-4 2-4 4v2c0 2 2 4 4 4M60 20c2 0 4 2 4 4v2c0 2-2 4-4 4" />
      </svg>

      {/* Documento com assinatura */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--document" viewBox="0 0 48 60">
        <path {...s} d="M10 6h20l8 8v40H10z" />
        <path {...s} d="M30 6v8h8" />
        <path {...s} d="M16 22h20M16 30h16M16 38h12" />
        <path {...s} d="M16 48c4 2 8 4 14 2" />
      </svg>

      {/* Chave (direitos e garantias) */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--key" viewBox="0 0 56 28">
        <circle {...s} cx="12" cy="14" r="8" />
        <circle {...s} cx="12" cy="14" r="3" />
        <path {...s} d="M20 14h24M36 14v6M44 14v4M50 14v2" />
      </svg>

      {/* Escudo (proteção / defensoria) */}
      <svg className="app-sidebar__doodle app-sidebar__doodle--shield" viewBox="0 0 48 56">
        <path {...s} d="M24 4L6 12v16c0 14 8 22 18 26 10-4 18-12 18-26V12L24 4z" />
        <path {...s} d="M24 16v20M18 22h12" />
      </svg>
    </div>
  );
}
